export default function AccountDeletion() {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-sm mt-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Account Deletion Request</h1>

      <div className="space-y-6 text-gray-700 leading-relaxed">
        <p>
          This page explains what data FreshOrder holds for buyer accounts and how to request
          that your account and its data be deleted.
        </p>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. What Data We Hold</h2>
          <p>
            Buyer accounts on FreshOrder are set up by the food distributor (vendor) you order from.
            For your account, FreshOrder stores:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Contact information:</strong> your name and phone number, and an email address if you provided one</li>
            <li><strong>Order history:</strong> the orders you have placed with your vendor, including products, quantities, and delivery details</li>
            <li><strong>Device push tokens:</strong> if you enabled push notifications in the mobile app, a device token used to deliver them</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How to Request Deletion</h2>
          <p>
            To request deletion of your account and associated data, email{" "}
            <a href="mailto:hello@freshorder.io" className="text-blue-600 underline">
              hello@freshorder.io
            </a>{" "}
            from the email address or phone number on file for your account, and include:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>The name of the vendor (distributor) you order from</li>
            <li>The phone number on file for your account</li>
          </ul>
          <p className="mt-2">
            We use this information only to verify that the request comes from the account holder.
            Deletion requests are processed within <strong>30 days</strong>. Once processed, your
            account and personal data are removed; your vendor may retain records of past
            transactions where required for accounting or legal obligations.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Demo Accounts</h2>
          <p>
            Accounts created through the FreshOrder demo are temporary and are deleted
            automatically within 24 hours. No deletion request is needed for demo accounts.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Questions</h2>
          <p>
            If you have questions about account deletion or your data, contact us at:
          </p>
          <div className="mt-2">
            <p><strong>FreshOrder</strong></p>
            <p>Email: hello@freshorder.io</p>
          </div>
        </section>
      </div>
    </div>
  );
}
